import { ServiceData } from '../../service';
import db from '../../index';
import { entityServiceFactory } from '../../entityServiceFactory';

export interface SpilledSubstancesServiceData extends ServiceData {}
const { add, clear, addSync, stopDownloading, get, reset, requestDownloadAgain } =
  entityServiceFactory<SpilledSubstancesServiceData>(
    db,
    'spilledSubstancesService'
  );

export { add, clear, addSync, stopDownloading, get, reset, requestDownloadAgain };
